"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMeetingUserState = void 0;
var EMeetingUserState;
(function (EMeetingUserState) {
  /** конференция была начата и не закончена */
  EMeetingUserState["started"] = "started";
  /** конференция была закончена */
  EMeetingUserState["finished"] = "finished";
  /** конференция была отменена */
  EMeetingUserState["canceled"] = "canceled";
  /** @deprecated, use rescheduling */
  EMeetingUserState["rescheduled"] = "rescheduled";
  /** был отправлено предложение на перенос времени */
  EMeetingUserState["rescheduling"] = "rescheduling";
  /** был отправлено предложение на отмену */
  EMeetingUserState["canceling"] = "canceling";
  /**
   * ожидает подтверждения отмены или переноса времени
   *
   * @deprecated ? cancelWaiting || rescheduleWaiting || acceptanceWaiting
   */
  EMeetingUserState["waiting"] = "waiting";
  /** ожидает подтверждения отмены */
  EMeetingUserState["cancelWaiting"] = "cancelWaiting";
  /** ожидает подтверждения переноса времени */
  EMeetingUserState["rescheduleWaiting"] = "rescheduleWaiting";
  /** @deprecated, use acceptanceWaiting */
  EMeetingUserState["confirmationWaiting"] = "confirmationWaiting";
  /** ожидает подтверждения участия */
  EMeetingUserState["acceptanceWaiting"] = "acceptanceWaiting";
  /** начался или закончился недавно */
  EMeetingUserState["nearTime"] = "nearTime";
  /** Какое-то действие не было подтверждено */
  EMeetingUserState["notAccepted"] = "notAccepted";
  EMeetingUserState["paidMeeting"] = "paidMeeting";
  EMeetingUserState["gradedMeeting"] = "gradedMeeting";
  /** Типы участников */
  EMeetingUserState["owner"] = "owner";
  EMeetingUserState["acceptedParticipant"] = "acceptedParticipant";
  EMeetingUserState["participant"] = "participant";
  EMeetingUserState["guest"] = "guest";
  /** Что это за свойство? */
  EMeetingUserState["single"] = "single";
  EMeetingUserState["singleReservation"] = "singleReservation";
  EMeetingUserState["acceptRequired"] = "acceptRequired";
  EMeetingUserState["freeAcceptRequired"] = "freeAcceptRequired";
  EMeetingUserState["paidAcceptRequired"] = "paidAcceptRequired";
  EMeetingUserState["joinRequired"] = "joinRequired";
  EMeetingUserState["paidJoinRequired"] = "paidJoinRequired";
  EMeetingUserState["paidOrFreeParticipant"] = "paidOrFreeParticipant";
  EMeetingUserState["participantLimit"] = "participantLimit";
  EMeetingUserState["gradeMeeting"] = "gradeMeeting";
})(EMeetingUserState = exports.EMeetingUserState || (exports.EMeetingUserState = {}));
